import {ActionCreators} from 'redux-undo';
import {getIconById, selectedViewId} from '~/selectors/CanvasSelectors';
import {changeView} from '~/actions/CanvasActions';
import {is} from 'immutable';

const undoMiddleware = store => next => action => {
  if (
    action.type === ActionCreators.undo().type ||
    action.type === ActionCreators.redo().type
  ) {
    // Access the history state
    const state = store.getState();
    const iconHistory = state.icon;

    const past = iconHistory.past;
    const future = iconHistory.future;
    const present = iconHistory.present;

    let affectedIconIds = null;

    if (action.type === ActionCreators.undo().type && past.length > 0) {
      const previousState = past[past.length - 1];
      affectedIconIds = findAffectedIconIds(previousState, present);
    } else if (
      action.type === ActionCreators.redo().type &&
      future.length > 0
    ) {
      const nextState = future[0];
      affectedIconIds = findAffectedIconIds(present, nextState);
    }

    if (affectedIconIds?.length) {
      // set the current view
      const selectedIcon = getIconById(state)(affectedIconIds[0]);
      // if the selectedIcon.viewId is not the same as selectedViewId,
      // then change to that the view
      if (selectedIcon && selectedIcon?.viewId !== selectedViewId(state)) {
        // store.dispatch(selectIcons({iconIds: affectedIconIds}));
        store.dispatch(changeView(selectedIcon.viewId));
      }
    }
  }
  return next(action);
};

// Helper function to find the affected iconIds by comparing states
const findAffectedIconIds = (stateBefore, stateAfter) => {
  const iconsBefore = stateBefore;
  const iconsAfter = stateAfter;

  const affectedIconIds = [];

  // Find the iconIds that were changed
  iconsBefore.forEach((iconBefore, iconId) => {
    const iconAfter = iconsAfter.get(iconId);
    if (iconAfter && !is(iconBefore, iconAfter)) {
      affectedIconIds.push(iconId); // Icon was changed
    }
  });

  // Also check for icons that were added or removed
  iconsAfter.forEach((iconAfter, iconId) => {
    if (!iconsBefore.has(iconId)) {
      affectedIconIds.push(iconId); // Icon was added
    }
  });
  iconsBefore.forEach((iconBefore, iconId) => {
    if (!iconsAfter.has(iconId)) {
      affectedIconIds.push(iconId); // Icon was removed
    }
  });

  return affectedIconIds;
};

export default undoMiddleware;
